module.exports = __webpack_public_path__ + "static/media/hammer-1.bdf247ba.glb";